import { render, staticRenderFns } from "./QuickSaveLocal.vue?vue&type=template&id=daf82a7a&scoped=true&"
import script from "./QuickSaveLocal.vue?vue&type=script&lang=js&"
export * from "./QuickSaveLocal.vue?vue&type=script&lang=js&"
import style0 from "./QuickSaveLocal.vue?vue&type=style&index=0&id=daf82a7a&prod&scoped=true&lang=scss&"
import style1 from "./QuickSaveLocal.vue?vue&type=style&index=1&id=daf82a7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf82a7a",
  null
  
)

export default component.exports